import SaleInvoiceMdl from '@/models/Sale/SlSaleInvoice'

export default async rut => {
    //
    try {
        let response = await SaleInvoiceMdl.where('rut', rut)
            .where('receivable',1)
            .append('account_receivable')
            .get()
        return response
    } catch (error) {
        return error.response.data
    }
}
